export const STORAGEKEY = {
  SESSION_ID: "SESSION_ID",
  STORE_NAME: "storeName",
  TABLE_NO: "tableNo",
};
